// components/FormControllers/CompanyDirectorDetailsController.js

import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import CompanyDirectorDetails from '../FormInputs/CompanyDirectorDetails';

const CompanyDirectorDetailsController = ({
  name,
  label,
  company_number,
  register,
  errors,
  sx,
  helptext,
}) => {
  const { control } = useFormContext();

  //const companyNumber = watch(company_number);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={[]}
      render={({ field }) => (
        <CompanyDirectorDetails
          {...field}
          label={label}
          company_number={company_number}
          register
          errors
          sx = {field.sx || sx}
          helptext={helptext}
        />
      )}
    />
  );
};

export default CompanyDirectorDetailsController;
